import { Injectable } from '@angular/core';

import * as _ from 'lodash'

export interface EntitySelectInterface {
  value: string;
  viewValue: string;
}

@Injectable()
export class EntityFormDataService {

  public leaseManagementRiskNames = [
    'Scope and Scope Exception',
    'Commencement Date',
    'Lease Term',
    'Purchase Options',
    'Lease Payments',
    'Lessee Accounting',
    'Lessor Accounting',
    'Sale-and-Leaseback Transactions',
    'Asset Control',
    'Sublease Accounting',
    'Discount Rates Lessee Accounting',
    'Effective Date and Transition'
  ]

  public provisionNames = [
    'Term',
    'Termination',
    'Warranty',
    'Limitation of Liability',
    'Indemnification',
    'Cost and Attorney\'s Fees',
    'Force Majeure',
    'Insurance',
    'Renewal',
    'Arbitration',
    'Jurisdiction',
    'Waiver',
    'Severability',
    'Integration',
    'Attachments',
    'Notice',
    'Relationships',
    'Assignment',
    'Escrow'
  ]

  public riskDomain = [
    'Operational',
    'Clinical/Patient Safety',
    'Strategic',
    'Financial',
    'Human Capital',
    'Legal/Regulatory',
    'Technology',
    'Hazard',
    'Lease Accounting'
  ]

  public riskName = [
    'Credit/Collections',
    'Financial Performance',
    'Billing Accuracy/Compliance',
    'Payer/Mix Rebimbursement',
    'Pension/Retirement Obligations',
    'Philanthropy/Fund Raising Capital',
    'Failure to Meet Margin',
    'Uncompensated Care',
    'Access to Capital',
    'Contract Management',
    'Revenue Enhancement'
  ]

  public riskCategories = [
    '1',
    '2',
    '3',
    '4',
    '5'
  ]

  public suffixLabels = [
    'II',
    'III',
    'IV',
    'Esq.',
    'MD',
    'MBA',
    'Jr.',
    'Sr.',
    'PhD',
    'CPA',
    'JD',
    'DDS',
    'FACHE',
    'CHC',
    'PMP'
  ]


  public documentTitleTypes = [
    'Main Contract',
    'Amendment to Main Contract',
    'Exhibit/Schedule to Main Contract',
    'Purchase Order',
    'Business Associate Agreement',
    'Certificate of Insurance',
    'Business Justification Request Form',
    'Fair Market Value Analysis',
    'Notice',
    'Offer Letter',
    'Settlement',
    'Correspondence',
    'Non Disclosure Agreement',
    'Letter of Intent',
    'Memorandum of Understanding',
    'Master Services Agreement MSA',
    'Subordinate Agreement to MSA',
    'Assessment'
  ]

  public departmentTypes = [
    '999',
    'Administration',
    'Legal',
    'Fellowship',
    'Dental',
    'Finance',
    'Insurance',
    'Compliance',
    'Equipment',
    'Grants',
    'Information Security',
    'Information Technology',
    'Human Resources',
    'Managed Care',
    'Operations',
    'Purchasing',
    'Real Estate',
    'Residency',
    'Clinical Operations',
    'Marketing',
    'Sales',
    'Facilities'

  ]


  // this is new for add new person entity and gray box

  public personStatusTypes = [
    'Active',
    'Inactive',
    'Terminated',
    'Reassigned',
    'Discontinued',
    'Under Review'

  ]

  public personTitleTypes = [
    'Chairman',
    'Chairmand and CEO',
    'CEO',
    'President',
    'Senior Vice President',
    'Executive Vice President',
    'Director',
    'Senior Director',
    'Manager',
    'Senior Manager',
    'Chief Legal Officer',
    'Chief Medical Officer',
    'Chief Compliance Officer',
    'Corporate Secretary',
    'Board Member',
    'Chief Operations Officer',
    'General Manager',
    'Facility Manager',
    'Department Manager',
    'VP HR',
    'VP Finance',
    'VP Administration',
    'General Counsel'

  ]


  // this is new for add new party entity and gray box
  public partyStatusTypes = [
    'Active',
    'Inactive',
    'Suspended',
    'Probationary Period',
    'Discontinued',
    'Under Review'
  ]


  public coiCoverageTypes = [
    'Workers Compensation',
    'Professional Liability',
    'Malpractice',
    'Cyber',
    'Property',
    'Product Liability',
    'Personal Liability',
    'Vehicle',
    'Business Interruption',
    'Claims Made',
    'Tail',
    'Occurrence',
    'Claims Paid'
  ]


  // this is new for contract gray box
  public hrsaScopeTypes = [
    '5A - I',
    '5A - II',
    '5A - III'
  ]


  public partyTypes = [
    'Clinical Services Provider',
    'Physician',
    'Non-Clinical Services Provider',
    'Non-Physician Provider',
    'Provider',
    'Services Vendor',
    'IT Services Vendor',
    'Facilities Services Vendor',
    'Capital Equipment Vendor',
    'Purchased Services Vendor',
    'Locum Tenens',
    'Temporary Employment Agency',
    'Private Grantor',
    'Federal Grantor',
    'County Grantor',
    'State Grantor',
    'Other Grantor',
    'Consultant'

  ]

  public functionTypes = [
    'Signatory',
    'Approver',
    'Reviewer',
    'Requestor',
    'BAA Coordinator',
    'COI Coordinator',
    'Contract Coordinator',
    'Coordinator'

  ]

  //  add to Party
  public standingTypes = [
    'Qualified',
    'Not Qualified',
    'Disqualified',
    'Requalified',
    'Preferred',
    'Secondary',
    'Standby',
    'Green',
    'Yellow',
    'Red'

  ]

  // this is for important dates actions
  public actionTypes = [
    'Expiration',
    'Annual Review',
    'Review',
    'Request',
    'Final Approval',
    'Signature',
    'Evaluation',
    'Termination',
    'Renegotiate',
    'Amend',
    'Revise',
    'Renew',
    'Replace'

  ]

  public userRoles = [
    'System Administrator',
    'Administrator',
    'Editor',
    'Viewer',
    'Requestor',
    'Timekeeper'
  ]

  public prefixLabels = [
    'Mr.',
    'Mrs.',
    'Ms.',
    'Miss',
    'Mx.',
    'Dr.',
    'Prof.',
    'Father',
    'Sister',
    'Brother',
    'Attorney',
    'Minister',
    'Counselor',
    'Rabbi',
    'Reverend',
    'Judge',
    'Honorable',
    'Dean',
    'Friar',
    'Chancellor',
    'Governor',
    'Justice',
    'President',
    'Representative',
    'Venerable'
  ]


  public programKeys = [
    'Medical',
    'Administration',
    'Dental',
    'Telemedicine',
    'SOHIP',
    'Early Intervention Services'
  ]

  // this is new for add new contract add form and contract details
  public grantProgramTypes = [
    '1000',
    '1100',
    '1500',
    '2000',
    '2100',
    '3000'
  ]


    // this is new for contract add form and details
    public grantRestrictionsTypes = [
      'Restricted',
      'Unrestricted',
      'Temporarily Restricted',
  ]

    public grantUseList = [
        'Operational',
        'Equipment',
        'Operational-Equipment',
        'Operational-Payroll',
        'Payroll Only'
    ]


  public serviceTypes = [
    'Purchasing',
    'Grants',
    'Grants - Federal - Exchange',
    'Grants - Federal - Contribution',
    'Grants - Federal - Reimbursable',
    'Grants - Private - Exchange',
    'Grants - Private - Contribution',
    'Grants - Private - Reimbursable',
    'Grants - State - Exchange',
    'Grants - State - Contribution',
    'Grants - State - Reimbursable',
    'Grants - County - Exchange',
    'Grants - County - Contribution',
    'Grants - County - Reimbursable',
    'Grants - Other - Exchange',
    'Grants - Other - Contribution',
    'Grants - Other - Reimbursable',
    'Grants - Federal - Operational',
    'Grants - Private - Operational',
    'Grants - State - Operational',
    'Grants - County - Operational',
    'Grants - Other - Operational',
    'IT Hardware',
    'IT Software',
    'IT Services',
    'Capital Expense <$100,000.00',
    'Capital Expense >$100,000.00',
    'Managed Care',
    'Facilities',
    'Hospice',
    'Finance',
    'Patient Care',
    'Affiliation Agreement',
    'Proposal',
    'Affiliation Agreement',
    'Credit Facility',
    'Clinical Provider - Employee',
    'Capital Lease Agreement',
    'Clinical Provider - Independent Contractor',
    'Corporate Documentation',
    'Business Associate Agreement',
    'Certificate of Insurance',
    'Clinical Rotation Agreement',
    'Construction Agreement',
    'Consulting Agreement',
    'Clinical Trial Agreement',
    'Data Use and Sharing Agreement',
    'Dental Employment Agreement',
    'Engagement Letter',
    'Equipment and Facility Lease',
    'Equipment Lease',
    'Equipment 3 - Purchase Order',
    'Equipment Upgrade',
    'Executive Employment Agreement',
    'Financing Agreement',
    'Human Resources - Benefits',
    'Independent Contractor Agreement',
    'Insurance Agreement',
    'Leased Personnel Agreement',
    'License and Software Maintenance Agreement',
    'License and Software Purchase Agreement',
    'Maintenance Agreement - Facilities',
    'Managed Care Agreement',
    'Master Service Agreement',
    'Membership Agreement',
    'Paraprofessional Employment Agreement',
    'Preceptor Agreement',
    'Physician Employment Agreement',
    'Professional Service Agreement',
    'Provider Services Agreement',
    'Real Estate Lease - Tenant',
    'Real Estate Lease - Landlord',
    'Real Estate Transfer Agreement ',
    'Research Agreement',
    'Resident Agreement',
    'Subcontractor Agreement',
    'Transcription Agreement',
    'Transportation Agreement',
    'Utility - Electricity',
    'Utility - Heat',
    'Utility - Telecommunications/Internet Connectivity ',
    'Utility - Water/Sewer'

  ];

  public contractTypes: EntitySelectInterface[] = [
    {value: 'Purchasing', viewValue: 'Purchasing'},
    {value: 'Grants - Federal - Exchange', viewValue: 'Grants - Federal - Exchange'},
    {value: 'Grants - Federal - Contribution', viewValue: 'Grants - Federal - Contribution'},
    {value: 'Grants - Federal - Reimbursable', viewValue: 'Grants - Federal - Reimbursable'},
    {value: 'Grants - Private - Exchange', viewValue: 'Grants - Private - Exchange'},
    {value: 'Grants - Private - Contribution', viewValue: 'Grants - Private - Contribution'},
    {value: 'Grants - Private - Reimbursable', viewValue: 'Grants - Private - Reimbursable'},
    {value: 'Grants - State - Exchange', viewValue: 'Grants - State - Exchange'},
    {value: 'Grants - State - Contribution', viewValue: 'Grants - State - Contribution'},
    {value: 'Grants - State - Reimbursable', viewValue: 'Grants - State - Reimbursable'},
    {value: 'Grants - County - Exchange', viewValue: 'Grants - County - Exchange'},
    {value: 'Grants - County - Contribution', viewValue: 'Grants - County - Contribution'},
    {value: 'Grants - County - Reimbursable', viewValue: 'Grants - County - Reimbursable'},
    {value: 'Grants - Other - Exchange', viewValue: 'Grants - Other - Exchange'},
    {value: 'Grants - Other - Contribution', viewValue: 'Grants - Other - Contribution'},
    {value: 'Grants - Other - Reimbursable', viewValue: 'Grants - Other - Reimbursable'},
    {value: 'Private Exchange Grant', viewValue: 'Private Exchange Grant'},
    {value: 'Facilities', viewValue: 'Facilities'},
    {value: 'Hospice', viewValue: 'Hospice'},
    {value: 'Finance', viewValue: 'Finance'},
    {value: 'Patient Care', viewValue: 'Patient Care'},
    {value: 'IT Hardware', viewValue: 'IT Hardware'},
    {value: 'IT Software', viewValue: 'IT Software'},
    {value: 'IT Services', viewValue: 'IT Services'},
    {value: 'Capital Expense <$100,000.00', viewValue: 'Capital Expense <$100,000.00'},
    {value: 'Capital Expense >$100,000.00', viewValue: 'Capital Expense >$100,000.00'},
    {value: 'Affiliation Agreement', viewValue: 'Affiliation Agreement'},
    {value: 'Credit Facility', viewValue: 'Credit Facility'},
    {value: 'Clinical Provider - Employee', viewValue: 'Clinical Provider - Employee'},
    {value: 'Capital Lease Agreement', viewValue: 'Capital Lease Agreement'},
    {value: 'Clinical Provider - Independent Contractor', viewValue: 'Clinical Provider - Independent Contractor'},
    {value: 'Corporate Documentation', viewValue: 'Corporate Documentation'},
    {value: 'Business Associate Agreement', viewValue: 'Business Associate Agreement'},
    {value: 'Certificate of Insurance', viewValue: 'Certificate of Insurance'},
    {value: 'Clinical Rotation Agreement', viewValue: 'Clinical Rotation Agreement'},
    {value: 'Construction Agreement', viewValue: 'Construction Agreement'},
    {value: 'Consulting Agreement', viewValue: 'Consulting Agreement'},
    {value: 'Clinical Trial Agreement', viewValue: 'Clinical Trial Agreement'},
    {value: 'Data Use and Sharing Agreement', viewValue: 'Data Use and Sharing Agreement'},
    {value: 'Dental Employment Agreement', viewValue: 'Dental Employment Agreement'},
    {value: 'Engagement Letter', viewValue:  'Engagement Letter'},
    {value: 'Equipment and Facility Lease', viewValue: 'Equipment and Facility Lease'},
    {value: 'Equipment Lease', viewValue: 'Equipment Lease'},
    {value: 'Equipment 3 - Purchase Order', viewValue: 'Equipment 3 - Purchase Order'},
    {value: 'Equipment Upgrade', viewValue: 'Equipment Upgrade'},
    {value: 'Executive Employment Agreement', viewValue: 'Executive Employment Agreement'},
    {value: 'Financing Agreement', viewValue: 'Financing Agreement'},
    {value: 'Human Resources - Benefits', viewValue: 'Human Resources - Benefits'},
    {value: 'Independent Contractor Agreement', viewValue: 'Independent Contractor Agreement'},
    {value: 'Insurance Agreement', viewValue: 'Insurance Agreement'},
    {value: 'Leased Personnel Agreement', viewValue: 'Leased Personnel Agreement'},
    {value: 'License and Software Maintenance Agreement', viewValue: 'License and Software Maintenance Agreement'},
    {value: 'License and Software Purchase Agreement', viewValue:  'License and Software Purchase Agreement'},
    {value: 'Maintenance Agreement - Facilities', viewValue:  'Maintenance Agreement - Facilities'},
    {value: 'Managed Care Agreement', viewValue: 'Managed Care Agreement'},
    {value: 'Master Service Agreement', viewValue: 'Master Service Agreement'},
    {value: 'Membership Agreement', viewValue:  'Membership Agreement'},
    {value: 'Paraprofessional Employment Agreement', viewValue: 'Paraprofessional Employment Agreement'},
    {value: 'Preceptor Agreement', viewValue: 'Preceptor Agreement'},
    {value: 'Physician Employment Agreement', viewValue: 'Physician Employment Agreement'},
    {value: 'Professional Service Agreement', viewValue: 'Professional Service Agreement'},
    {value: 'Provider Services Agreement', viewValue: 'Provider Services Agreement'},
    {value: 'Real Estate Lease - Tenant', viewValue: 'Real Estate Lease - Tenant'},
    {value: 'Real Estate Lease - Landlord', viewValue: 'Real Estate Lease - Tenant'},
    {value: 'Real Estate Transfer Agreement', viewValue: 'Real Estate Transfer Agreement'},
    {value: 'Research Agreement', viewValue: 'Research Agreement'},
    {value: 'Resident Agreement', viewValue: 'Resident Agreement'},
    {value: 'Subcontractor Agreement', viewValue:  'Subcontractor Agreement'},
    {value: 'Transcription Agreement', viewValue: 'Transcription Agreement'},
    {value: 'Transportation Agreement', viewValue:  'Transportation Agreement'},
    {value: 'Utility - Electricity', viewValue: 'Utility - Electricity'},
    {value: 'Utility - Heat', viewValue: 'Utility - Heat'},
    {value: 'Utility - Telecommunications/Internet Connectivity', viewValue: 'Utility - Telecommunications/Internet Connectivity'},
    {value: 'Utility - Water/Sewer', viewValue: 'Utility - Water/Sewer'},
    {value: 'Grants - Federal - Operational', viewValue: 'Grants - Federal - Operational'},
    {value:'Grants - Private - Operational', viewValue: 'Grants - Private - Operational'},
    {value:'Grants - State - Operational', viewValue: 'Grants - State - Operational'},
    {value:'Grants - County - Operational', viewValue: 'Grants - County - Operational'},
    {value:'Grants - Other - Operational', viewValue: 'Grants - Other - Operational'},
    {value: 'Proposal', viewValue: 'Proposal'}

  ];

  public statusTypes: EntitySelectInterface[] = [
      {value: 'Draft in Review', viewValue: 'Draft in Review'},
      {value: 'Submitted for Review', viewValue: 'Submitted for Review'},
      {value: 'Active in Review', viewValue: 'Active in Review'},
      {value: 'Requested', viewValue: 'Requested'},
      {value: 'Pending Approval', viewValue: 'Pending Approval'},
      {value: 'Pending Signature', viewValue: 'Pending Signature'},
      {value: 'Active-Initial', viewValue: 'Active-Initial Term'},
      {value: 'Active-Renewed', viewValue: 'Active-Renewed'},
      {value: 'Canceled', viewValue: 'Canceled/Reversed'},
      {value: 'Terminated', viewValue: 'Terminated'},
      {value: 'Retired', viewValue: 'Retired'}
    ];

  public versionTypes: EntitySelectInterface[] = [
      {value: 'Original', viewValue: 'Original'},
      {value: 'Revised/Expanded', viewValue: 'Revised/Expanded'},
      {value: 'Replaced', viewValue: 'Replaced'}
    ];

  public contractLabels: EntitySelectInterface[] = [
      {value: 'Master Services Agreement', viewValue: 'Master Services Agreement'},
      {value: 'Subordinate Agreement', viewValue: 'Subordinate Agreement'}
    ];

  public salutationLabels: EntitySelectInterface[] = [
      {value: 'Mr.', viewValue: 'Mr.'},
      {value: 'Ms.', viewValue: 'Ms.'},
      {value: 'Mrs.', viewValue: 'Mrs.'}
    ];

  public renewalTypeLabels: EntitySelectInterface[] = [
      {value: 'Auto Original Term', viewValue: 'Auto Original Term'},
      {value: 'Auto Multi-Year', viewValue: 'Auto Multi-Year'},
      {value: 'Auto 1 Year', viewValue: 'Auto 1 Year'},
      {value: 'Month to Month', viewValue: 'Month to Month'},
      {value: 'Non-Renewable', viewValue: 'Non-Renewable'},
      {value: 'Not Automatic', viewValue: 'Not Automatic'},
      {value: 'One Time Purchase', viewValue: 'One Time Purchase'}
    ];


  constructor() { }

  getLeaseManagementRiskNames(): any {
    return this.leaseManagementRiskNames;
  }

  getProvisionNames(): any {
    return this.provisionNames;
  }

  getRiskNames(): any {
    return this.riskName;
  }

  getRiskDomains(): any {
    return this.riskDomain;
  }

  getRiskCategories(): any {
    return this.riskCategories;
  }

  getGrantUseList(): any {
    return this.grantUseList;
  }

  getProgramKeys(): any {
    return this.programKeys;
  }

  getDepartmentTypes(): any {
    return this.departmentTypes;
  }

  getGrantRestrictionsTypes(): any {
    return this.grantRestrictionsTypes;
  }

  getPersonStatusTypes(): any {
    return this.personStatusTypes;
  }

  getPersonTitleTypes(): any {
    return this.personTitleTypes;
  }

  getPartyStatusTypes(): any {
    return this.partyStatusTypes;
  }

  getCOICoverageTypes(): any {
    return this.coiCoverageTypes;
  }

  getHRSAScopeTypes(): any {
    return this.hrsaScopeTypes;
  }

  getPartyTypes(): any {
    return this.partyTypes;
  }

  getFunctionTypes(): any {
    return this.functionTypes;
  }

  getStandingTypes(): any {
    return this.standingTypes;
  }

  getGrantProgramNumberTypes(): any {
    return this.grantProgramTypes;
  }

  getActionTypes(): any {
    return this.actionTypes;
  }

  getDocumentTitleTypes(): any {
    return this.documentTitleTypes;
  }

  getSuffixLabels(): any {

   return this.suffixLabels;
  }

  getUserRoles(): any {
    return this.userRoles;
  }

  getPrefixLabels(): any {
    return this.prefixLabels;
  }


  getServiceTypes(): any {
    return this.serviceTypes;
  }

  getRenewalTypeLables(): EntitySelectInterface[] {
    return this.renewalTypeLabels;
  }


  getSalutationLabels(): EntitySelectInterface[] {

    return this.salutationLabels;
  }


  getContractLabels(): EntitySelectInterface[] {

    return this.contractLabels;
  }

  getContractTypes(): EntitySelectInterface[] {

    return this.contractTypes;
  }

  getStatusTypes(): EntitySelectInterface[] {

    return this.statusTypes;
  }

  getVersionTypes(): EntitySelectInterface[] {

    return this.versionTypes;
  }


}
